import { CARE_STAFF_ROLES } from '@aithora/shared';
import { useConsoleRole } from '../../session/SessionContext';
import { ReadOnlyNote } from '../../ui/ReadOnly';
import { RichCompanion } from './RichCompanion';
import { ResidentCompanion } from './ResidentCompanion';
import { FamilyCompanion } from './FamilyCompanion';
import { MemberCompanion } from './MemberCompanion';
import './companion.css';

/**
 * Atlas, one surface per role (design isCompanion, T254-1332): Family (what she
 * agreed to share), Aithora Home (the member's own chat), Resident (Talk, My day, About
 * me), and the staff surface for Operator (Partner read only), Facility Admin and Care
 * Staff. The role comes from the session only (or the role a Super Admin views as).
 */
export function Companion() {
  const { role } = useConsoleRole();
  if (!role) return null;
  if (role === 'FAMILY_MEMBER') return <FamilyCompanion />;
  if (role === 'MEMBER') return <MemberCompanion />;
  if (role === 'RESIDENT') return <ResidentCompanion />;
  if (role === 'ADMIN') return <RichCompanion lens="admin" />;
  if (CARE_STAFF_ROLES.has(role)) return <RichCompanion lens="care" />;
  return (
    <>
      <ReadOnlyNote />
      <RichCompanion lens="op" />
    </>
  );
}
